import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700">
    <title>Loader Logo</title>
    <g>
      <g
        id="B"
        transform="translate(0.000000,700.000000) scale(0.1000000,-0.100000)"
        fill="transparent">
        <path
          d="M0 3500 l0 -3500 3500 0 3500 0 0 3500 0 3500 -3500 0 -3500 0 0
-3500z m3619 1154 c92 -23 176 -69 244 -134 61 -60 70 -89 40 -122 -28 -31
-62 -22 -118 31 -63 60 -132 96 -210 110 -36 7 -210 11 -447 11 l-388 0 2
-407 3 -408 355 -3 c195 -1 392 2 437 7 90 11 166 42 229 94 46 38 111 138
120 183 11 57 67 82 106 47 25 -22 23 -52 -8 -125 -68 -162 -216 -280 -391
-314 -57 -11 -168 -14 -464 -14 l-389 0 0 -419 0 -419 115 -116 115 -115 0
472 c0 521 0 517 60 517 44 0 60 -23 60 -86 l0 -55 438 3 437 3 60 29 c158 78
253 257 226 427 -28 168 -155 304 -319 338 -34 7 -197 11 -448 11 l-394 0 1
-169 c1 -193 -4 -211 -56 -211 -62 0 -65 14 -65 273 l0 228 493 -4 c531 -3
519 -2 633 -60 68 -35 150 -110 196 -181 152 -235 91 -551 -136 -710 -134 -94
-204 -106 -616 -106 -157 0 -322 0 -368 0 l-84 0 2 -87 c1 -49 2 -276 1 -506
l-1 -418 -235 235 -235 235 0 976 0 975 467 0 c396 0 477 -2 532 -16z"
          strokeWidth="100"
          stroke="#64FFDA"
        />
      </g>
    </g>
  </svg>
);

export default IconLoader;
